import React from "react";
import { renderRoutes } from "react-router-config";
import { Redirect } from "react-router-dom";
import CadastroComponent from "./main";
import Storage from "@/app/core/util/Storage";

const EmptyRouter = props =>
  Storage.isAuthenticated() ? (
    <Redirect to="/" />
  ) : (
    <div {...props}>{renderRoutes(props.route.routes, props)}</div>
  );

const CadastroRouter = () => ({
  path: "/cadastro",
  exact: true,
  component: EmptyRouter,
  routes: [
    {
      path: "/cadastro",
      component: CadastroComponent
    }
  ]
});

export default CadastroRouter();
